var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group-info" }, [
    _c("div", { staticClass: "group-info__logo" }, [
      _vm.showLogo
        ? _c("img", {
            staticClass: "img-logo",
            attrs: { src: _vm.data.imgSrc }
          })
        : _c("span", { staticClass: "text-logo" }, [
            _vm._v(_vm._s(_vm.groupName.substring(0, 1)))
          ])
    ]),
    _c("div", { staticClass: "group-info__title" }, [
      _vm.groupNameImg
        ? _c("img", { attrs: { src: _vm.groupNameImg } })
        : _vm._e()
    ]),
    _vm.data.extraInfo
      ? _c("div", {
          staticClass: "group-info__extra",
          domProps: { innerHTML: _vm._s(_vm.data.extraInfo) }
        })
      : _vm._e(),
    _vm.data.descNoInfo
      ? _c("div", {
          staticClass: "group-info__extra",
          domProps: { innerHTML: _vm._s(_vm.data.descNoInfo) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18a79e82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a79e82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/GroupInfo.vue
// module id = oKr7
// module chunks = 1 2 3 4 5